import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

const CHAPTERS = [
  {
    num: "01",
    title: "It picks up.",
    body: "Every call answered on the first ring — day, night, weekends, holidays. No voicemail, no missed lead, no lost revenue.",
  },
  {
    num: "02",
    title: "It remembers.",
    body: "Every customer, every conversation, one shared memory. It greets returning callers by name and picks up right where you left off.",
  },
  {
    num: "03",
    title: "It books.",
    body: "Qualified appointments dropped straight into your calendar while you sleep. You wake up to a fuller schedule, not a full voicemail.",
  },
  {
    num: "04",
    title: "You grow.",
    body: "No missed leads. More booked jobs. Less busywork. The kind of business you wanted when you started it.",
  },
];

const Chapter = ({ c, index }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "start center"] });
  const opacity = useTransform(scrollYProgress, [0, 1], [0.25, 1]);
  const x = useTransform(scrollYProgress, [0, 1], [index % 2 ? 40 : -40, 0]);

  return (
    <motion.div
      ref={ref}
      style={{ opacity }}
      className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 items-baseline py-10 md:py-14 border-t border-white/10"
    >
      <div className="md:col-span-4">
        <span className="font-heading text-6xl md:text-8xl font-black leading-none text-transparent [-webkit-text-stroke:1px_rgba(255,92,0,0.5)]">
          {c.num}
        </span>
      </div>
      <motion.div style={{ x }} className="md:col-span-8">
        <h3 className="font-heading text-3xl md:text-5xl font-bold tracking-tight text-white">{c.title}</h3>
        <p className="mt-4 text-base md:text-lg text-white/55 max-w-xl leading-relaxed">{c.body}</p>
      </motion.div>
    </motion.div>
  );
};

export const Manifesto = () => {
  return (
    <section data-testid="manifesto-section" className="relative py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="max-w-2xl"
        >
          <span className="text-xs tracking-[0.25em] uppercase font-bold text-brand">The 5B AI promise</span>
          <h2 className="font-heading mt-4 text-3xl md:text-5xl font-bold tracking-tight text-white leading-tight">
            Four things it does, so you don't have to.
          </h2>
        </motion.div>

        <div className="mt-12">
          {CHAPTERS.map((c, i) => (
            <Chapter key={c.num} c={c} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
};
